import React from 'react';
import Logo from './Logo';
import './Header.css';

const Header = () => {
  return (
    <header className="header">
      <div className="container">
        <Logo />
      </div>
    </header>
  );
};

export default Header;

